import { Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  translationConstants,
  subscriptionTypeConstants,
  paymentType,
  paymentCardRadioButtonConstants,
  viewPathConstants,
  Directions,
  globalConstants,
  genderEnumReversed,
  StorageKeys,
  paymentFormDivIds,
  paymentPriceTypeConstants,
  calculationOperations,
} from "../../../constants";
import {
  paymentActions,
  SubscriptionActions,
  EventActions,
  competitionActions,
} from "../../../redux/actions";
import {
  renderPaymentform,
  hyperpayFormCustomJS,
  unloadWidget,
  getUserPayload,
  setLocalStorageItem,
  encryptObject,
  hyperpaySaveCardFormCustomJS,
  calculateVAT,
  precisionCalculation,
} from "../../../system";
import { LockIcon, BreakdownIcon } from "../../../assets/images/icon";

import CustomModal from "../CustomModal/CustomModal";
import PricingModal from "../Modals/PricingModal";

const RegistrationPaymentModal = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userPayload = getUserPayload();

  const [totalFee, setTotalFee] = useState(null);
  const [isLoadCustomJS, setLoadCustomJS] = useState("");
  const [priceBreakdown, setPriceBreakdown] = useState(null);
  const [paymentPriceType, setPaymentPriceType] = useState(null);
  const [isPriceBreakdownModal, setPriceBreakdownModal] = useState(null);
  const [isBoatClassSelected, setIsBoatClassSelected] = useState(false);
  const [boatClassError, setBoatClassError] = useState("");
  const [cardUsageState, setCardUsageState] = useState(
    paymentCardRadioButtonConstants.NEWCARD
  );

  const subscriptionPrices = useSelector(
    (state) => state.SubscriptionReducer.subscriptionPrices
  );
  const competitionData = useSelector(
    (state) => state.CompetitionReducer.competitionPublicDataById
  );
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  const userBoatClass = useSelector(
    (state) => state.CompetitionReducer?.userBoatClass
  );
  const checkoutIdSavedCard = useSelector(
    (state) => state.PaymentReducer.checkoutIdSavedCard
  );
  const savedcards = useSelector(
    (state) => state.PaymentReducer.savedPaymentCards
  );
  const checkoutId = useSelector((state) => state.PaymentReducer.CheckoutID);
  const eventData = useSelector((state) => state.eventReducer.eventDataById);

  const priceBreakdownHandler = (subTotal) => {
    const vat = subscriptionPrices?.find(
      (x) => x.subcriptionType === subscriptionTypeConstants.VAT
    );
    const vatValue = calculateVAT(vat?.price, subTotal);
    setPriceBreakdown({
      subTotal: subTotal,
      vat: vat?.price,
      vatValue: vatValue,
      totalFees: vatValue + subTotal,
    });
  };

  const priceCalculationHandler = (vat, price) => {
    const vatIncludedPrice = precisionCalculation(
      calculateVAT(vat?.price, price),
      price,
      calculationOperations.addition
    );
    return vatIncludedPrice;
  };

  const handleBoatClassChange = (event) => {
    const selectedValue = event.target.value;
    setLocalStorageItem(
      StorageKeys.userBoatClassForCompetitionRegistration,
      encryptObject(selectedValue)
    );
    setIsBoatClassSelected(!!selectedValue);
    if (selectedValue) {
      setBoatClassError("");
    } else {
      setBoatClassError(
        t(translationConstants.COMPETITION_BOAT_CLASS_REQUIRED)
      );
    }
  };

  const renderForm = (id, formDivId, cardType) => {
    renderPaymentform(
      id,
      props.type === paymentType.Competition
        ? viewPathConstants.PUBLIC_COMPETITIONS
        : viewPathConstants.VIEW_EVENTS,
      "",
      formDivId,
      setLoadCustomJS,
      cardType
    );
  };

  const resetForm = () => {
    setLoadCustomJS("");
    dispatch(paymentActions.paymentCheckoutNull());
    unloadWidget();
  };

  useEffect(() => {
    dispatch(
      SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
    );
    dispatch(
      paymentActions.getSavedPaymentCard({
        systemUserId: userPayload?.user?.id,
      })
    );
    if (props.type === paymentType.Event) {
      dispatch(EventActions.getEventById(props.eventID));
    } else if (props.type === paymentType.Competition) {
      dispatch(competitionActions.getPublicCompetitionById(props.eventID));
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isLoadCustomJS === paymentCardRadioButtonConstants.NEWCARD) {
      hyperpayFormCustomJS(t, direction, false, true, false);
    } else if (isLoadCustomJS === paymentCardRadioButtonConstants.SAVEDCARDS) {
      hyperpaySaveCardFormCustomJS(t, direction);
    }
    //eslint-disable-next-line
  }, [isLoadCustomJS]);

  useEffect(() => {
    if (totalFee !== null) {
      if (
        cardUsageState === paymentCardRadioButtonConstants.NEWCARD &&
        checkoutId !== null
      ) {
        renderForm(
          checkoutId,
          paymentFormDivIds.newCardForm,
          paymentCardRadioButtonConstants.NEWCARD
        );
      } else if (
        cardUsageState === paymentCardRadioButtonConstants.SAVEDCARDS &&
        checkoutIdSavedCard !== null
      ) {
        renderForm(
          checkoutIdSavedCard,
          paymentFormDivIds.savedCardForm,
          paymentCardRadioButtonConstants.SAVEDCARDS
        );
      }
    }
    //eslint-disable-next-line
  }, [cardUsageState, checkoutId, checkoutIdSavedCard]);

  useEffect(() => {
    if (totalFee) {
      const commonPayload = {
        price: totalFee?.toFixed(2),
        systemUserId: userPayload?.user?.id,
        priceType: paymentPriceType,
      };

      if (
        cardUsageState === paymentCardRadioButtonConstants.NEWCARD &&
        checkoutId === null
      ) {
        const payload = {
          ...commonPayload,
          paymentType: props.type,
          createRegistration: false,
          ...(props.type === paymentType.Event
            ? { eventId: props.eventID }
            : { competitionId: props.eventID }),
        };
        dispatch(paymentActions.paymentCheckout(payload));
      } else if (
        cardUsageState === paymentCardRadioButtonConstants.SAVEDCARDS &&
        checkoutIdSavedCard === null
      ) {
        const payload = {
          ...commonPayload,
          paymentType: props.type,
          ...(props.type === paymentType.Event
            ? { eventId: props.eventID }
            : { competitionId: props.eventID }),
        };
        dispatch(paymentActions.paymentCheckoutSavedCard(payload));
      }
    }
    //eslint-disable-next-line
  }, [totalFee, cardUsageState]);

  useEffect(() => {
    let vatIncludedFee = 0;
    const vatData = subscriptionPrices.find(
      (x) => x.subcriptionType === subscriptionTypeConstants.VAT
    );
    if (props.type === paymentType.Event) {
      const eventFullfee = eventData?.totalFee;
      const eventDiscountedFee = eventData?.specialMemberFee;
      if (eventFullfee && vatData) {
        if (
          userPayload?.user?.isMembershipHolder &&
          eventData?.specialMemberFee
        ) {
          setPaymentPriceType(paymentPriceTypeConstants.SpecialMember);
          vatIncludedFee = priceCalculationHandler(vatData, eventDiscountedFee);
          priceBreakdownHandler(eventDiscountedFee);
        } else {
          setPaymentPriceType(paymentPriceTypeConstants.Registration);
          vatIncludedFee = priceCalculationHandler(vatData, eventFullfee);
          priceBreakdownHandler(eventFullfee);
        }
      }
    } else if (props.type === paymentType.Competition) {
      const competitionFullfee = competitionData?.registrationFee;
      const competitionDiscountedFee = competitionData?.specialMembersFee;
      if (competitionFullfee && vatData) {
        if (
          userPayload?.user?.isMembershipHolder &&
          competitionData?.specialMembersFee
        ) {
          setPaymentPriceType(paymentPriceTypeConstants.SpecialMember);
          vatIncludedFee = priceCalculationHandler(
            vatData,
            competitionDiscountedFee
          );
          priceBreakdownHandler(competitionDiscountedFee);
        } else {
          setPaymentPriceType(paymentPriceTypeConstants.Registration);
          vatIncludedFee = priceCalculationHandler(vatData, competitionFullfee);
          priceBreakdownHandler(competitionFullfee);
        }
      }
    }

    setTotalFee(vatIncludedFee);
    //eslint-disable-next-line
  }, [subscriptionPrices, eventData, competitionData]);

  useEffect(() => {
    if (props.type === paymentType.Competition) {
      // Function to enforce button state
      const enforceButtonState = () => {
        const paymentButton = document.getElementsByClassName("wpwl-button")[0];
        if (paymentButton) {
          if (!isBoatClassSelected) {
            paymentButton.disabled = true; // Ensure button stays disabled
            setBoatClassError(
              t(translationConstants.COMPETITION_BOAT_CLASS_REQUIRED)
            );
          } else {
            paymentButton.disabled = false; // Enable button if valid
            setBoatClassError("");
          }
        }
      };
      // Initial enforcement of the button state
      enforceButtonState();
      // Interval to continuously check and enforce button state
      const intervalId = setInterval(enforceButtonState, 50); // Check every 50ms
      // Clean up interval on unmount or dependencies change
      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line
  }, [isBoatClassSelected, t, translationConstants]);

  return (
    <div className="px-4 w-100">
      <div>
        <span className="loginPara">{props.title}</span>
        <hr className="horizontal-line" />

        {props?.type === paymentType.Competition && (
          <Form.Group className="mx-0 mt-2 mb-4">
            <Form.Label className="font-13 font-weight-700">
              {`${t(translationConstants.CHOOSE_BOAT_CLASS_FOR_COMPETITION)}:` +
                globalConstants.Mandatory_Character}
            </Form.Label>
            <Form.Select
              id="userBoatClassForCompetition"
              onChange={handleBoatClassChange}
            >
              <option value="">
                {t(translationConstants.SELECT_BOAT_CLASSS)}
              </option>
              {userBoatClass?.map((object) => {
                const name =
                  direction === Directions.rtl && object.arabicName
                    ? object.arabicName
                    : object.name;
                const genderText = t(
                  translationConstants[genderEnumReversed[object.gender]]
                );
                return (
                  <option key={object.id} value={object.id}>
                    {`${name} - ${genderText}`}
                  </option>
                );
              })}
            </Form.Select>
            {boatClassError && <p className="errorText">{boatClassError}</p>}
          </Form.Group>
        )}

        <div className="row mx-0 my-2">
          <Col md={6} className="p-0">
            <p className="text-dark font-weight-700">
              <span className="font-weight-700">
                {`${t(translationConstants.TOTAL_FEE)}:`}
              </span>
            </p>
          </Col>
          <Col
            md={6}
            className={`p-0 d-flex align-items-center justify-content-end`}
          >
            <div
              className={`d-flex align-items-center justify-content-end gap-2 fw-bold text-end text-dark`}
            >
              <div
                className={`d-flex flex-column ${
                  direction === Directions.rtl ? "text-start" : "text-end"
                }`}
              >
                {translationConstants.SAR} {totalFee?.toFixed(2)}
                <span className="font-10">
                  {t(translationConstants.VAT_INCLUDED)}
                </span>
              </div>
              <span className="d-flex align-items-center info-icon">
                <img
                  alt="img-info"
                  src={BreakdownIcon}
                  onClick={() => setPriceBreakdownModal(true)}
                />
              </span>
            </div>
          </Col>
        </div>

        <div className="row mx-0 my-2">
          <Col md={6} className="p-0">
            <p className="text-dark font-weight-700">
              <span className="font-weight-700">
                {t(translationConstants.PAYMENT_METHOD)}:
              </span>
            </p>
          </Col>
          <Col
            md={6}
            className="d-flex align-items-center justify-content-end p-0"
          >
            <div className="d-flex gap-1 align-items-center">
              <img
                className="secured-by-hyperpay-img"
                src={LockIcon}
                alt="secure lock icon"
              />
              <span className="secured-by-hyperpay-text">
                {t(translationConstants.SECURED_BY_HYPERPAY)}
              </span>
            </div>
          </Col>
        </div>

        {savedcards?.count > 0 && (
          <div className="d-flex gap-3">
            <Form.Check
              type="radio"
              label={t(translationConstants.USE_SAVED_CARD)}
              name={`radioGroup`}
              id={"savedcard"}
              value={paymentCardRadioButtonConstants.SAVEDCARDS}
              checked={
                cardUsageState === paymentCardRadioButtonConstants.SAVEDCARDS
              }
              onChange={(e) => {
                resetForm();
                setCardUsageState(e.currentTarget?.value);
              }}
            />
            <Form.Check
              type="radio"
              label={t(translationConstants.USE_NEW_CARD)}
              name={`radioGroup`}
              id={"newCard"}
              value={paymentCardRadioButtonConstants.NEWCARD}
              checked={
                cardUsageState === paymentCardRadioButtonConstants.NEWCARD
              }
              onChange={(e) => {
                resetForm();
                setCardUsageState(e.currentTarget?.value);
              }}
            />
          </div>
        )}

        {cardUsageState === paymentCardRadioButtonConstants.NEWCARD &&
          totalFee !== null &&
          checkoutId && (
            <div id={paymentFormDivIds.newCardForm} className="pt-2"></div>
          )}

        {cardUsageState === paymentCardRadioButtonConstants.SAVEDCARDS &&
          totalFee !== null &&
          checkoutIdSavedCard && (
            <div id={paymentFormDivIds.savedCardForm} className="pt-4"></div>
          )}
      </div>

      <CustomModal
        size={"sm"}
        scrollable
        show={isPriceBreakdownModal}
        setShow={setPriceBreakdownModal}
        closeBtnClasses={"login-modal-close-btn"}
        customClass={"freelance-instructor-model-sm"}
        closeOnOutsideClick={true}
      >
        <PricingModal
          data={priceBreakdown}
          isEventCompetition={true}
          competitionData={competitionData}
          eventData={eventData}
          type={props.type}
        />
      </CustomModal>
    </div>
  );
};

export default RegistrationPaymentModal;
